module.exports = require("regenerator-runtime");



/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-preset-react-app/~/babel-runtime/regenerator/index.js
 ** module id = 846
 ** module chunks = 0
 **/